import { Badge, PaginationProps, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';
import { Device } from '../../gen/proto/api/gateway/v1/gateway_pb';
import DeleteDeviceButton from '../device/DeleteDeviceButton';

type DeviceGeneralTableProps = {
  data: readonly Device[];
  onRowClick: (record: Device) => void;
  pagination: PaginationProps;
  onChange: (pagination: PaginationProps) => void;
  onDeleteDevice: (id: string) => void;
};

const DeviceGeneralTable = (props: DeviceGeneralTableProps) => {
  const columns: ColumnsType<Device> = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      width: '60%',
      render: (text, record) => (
        <span className={'MainTableText'}>
          <Badge status={record.data?.connected ? 'success' : 'error'} />
          {text}
        </span>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: ['data', 'type'],
      key: 'type',
      width: '30%',
    },
    {
      title: 'Eliminar',
      key: 'delete',
      width: '10%',
      render: (_, record) => <DeleteDeviceButton uuid={record.uuid} onDeleteDevice={props.onDeleteDevice} />,
    },
  ];

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={props.data}
      pagination={{
        ...props.pagination,
        position: ['bottomCenter'],
      }}
      onChange={props.onChange}
      rowKey={(record) => record.uuid}
      onRow={(record) => {
        return {
          onClick: () => {
            props.onRowClick(record);
          },
        };
      }}
    />
  );
};

export default DeviceGeneralTable;
